


// // hero start


// $('.hero__bg-items').slick({
//   slidesToShow: 2,
//   slidesToScroll: 1,
//   arrows: false,
//   autoplay: true,
//   autoplaySpeed: 5000,
//   responsive: [
//       {
//           breakpoint: 768,
//           settings: {
//               slidesToShow: 1,
//               slidesToScroll: 1
//           }
//       },
//   ]
// });



// // hero end



// hero start


$(document).ready(function () {
if (localStorage.getItem('newsletterClosed') === 'true') {
  // already closed
}else{
  setTimeout(function () {
    $('body.template-deal').addClass('newsletter-active');
    // localStorage.setItem('newsletterClosed', 'true');
  }, 1000);
}

  


  // $('.newsletter__close , .overlay').on('click', function () {
  //   $('body').removeClass('newsletter-active');
  //   localStorage.setItem('newsletterClosed', 'true');
  // });


  // $('.newsletter__btn').on('click', function () {
  //   $('body').removeClass('newsletter-active');
  //   localStorage.setItem('newsletterClosed', 'true');
  //   // window.location.href = '/pages/new-deal'; 
  // });
});


$(document).ready(function () {
  // First slider (hero__bg-items 1)
  var firstSlider = $('.hero__bg-items-1').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    fade: true,
    autoplaySpeed: 4000,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
    ]
  });


  $('.hero__bg-items-2').slick({
    autoplay: false,
    fade: true,                
    autoplaySpeed: 4000,            
    pauseOnHover: false,            
    pauseOnFocus: false,
    arrows: false            
  });
  setTimeout(function () {
    $('.hero__bg-items-2').slick('slickPlay');  // Start autoplay after the delay
  }, 2000); 

  // Second slider (hero__bg-items 2)
});



// hero end




// cart start


$(".header__cart , .header__cart,.menu__bot_cart").on("click", function () {
  $("body").addClass("active-cart");
})


$(".cart__close , .overlay").on("click", function () {
  $("body").removeClass("active-cart");
})


// cart end





// login start


// $(".header__acc").on("click", function (e) {
//   $("body").addClass("active-login");
// })
$(".no__account").on("click", function (e) {
  e.preventDefault();
  $("body").addClass("active-login");
})





$(".account-and-login__close , .overlay").on("click", function (e) {
  e.preventDefault();
  $("body").removeClass("active-login");
})

$(".account-and-login__regi-link a").on("click", function (e) {
  e.preventDefault();
  $(".account-and-login-regi").show();
  $(".account-and-login_login").hide();
})

$(".account-and-login__log-link a").on("click", function (e) {
  e.preventDefault();
  $(".account-and-login_login").show();
  $(".account-and-login-regi").hide();
})

$(".account-and-login__forgot a").on("click", function (e) {
  e.preventDefault();
  $(".account-and-login-reset").show();
  $(".account-and-login_login").hide();
})
$(".account-and-login__back-login").on("click", function (e) {
  e.preventDefault();
  $(".account-and-login-reset").hide();
  $(".account-and-login_login").show();
})
$(".reset__password-back-login").on("click", function (e) {
  e.preventDefault();
  $(".account-and-login-confirm").hide();
  $(".account-and-login_login").show();
})


$(".add-address").on("click", function (e) {

  e.preventDefault();
  $("body").addClass("active-login");
  $(".add__address").show();
  $(".account-and-login_login").hide();
})

$(".edit-address").on("click", function (e) {

  e.preventDefault();
  $("body").addClass("open__edit-form");
})


$(".add-address").on("click", function (e) {

  e.preventDefault();
  $("body").addClass("open__add-form");
})


$(".account-and-login__close , .overlay").on("click", function (e) {
  e.preventDefault();
  $("body").removeClass("open__edit-form");
})


$(".account-and-login__close , .overlay").on("click", function (e) {
  e.preventDefault();
  $("body").removeClass("open__add-form");
})




document.querySelectorAll('.edit-address').forEach(button => {
  button.addEventListener('click', function () {
  
      const targetForm = this.getAttribute('data-form'); 

      // Hide all forms
      document.querySelectorAll('.address__form').forEach(form => {
          form.style.display = 'none';
        
      });

      // Show the matching form
      const formToShow = document.querySelector(targetForm);
      if (formToShow) {
          formToShow.style.display = 'block';
      } else {
          console.error(`Form with ID ${targetForm} not found.`);
      }
  });
});


$('.customer-input_country').each(function(){
  var my_country = $(this).attr('data-default');
  $(this).val(my_country);
  console.log(my_country);
});




document.addEventListener("DOMContentLoaded", function () {
  if (window.location.href.includes("/account/login#recover")) {
      document.body.classList.add("recover__password");
  }
});





// login end





// menu start


$(".header__mobi-menu").on("click", function () {
  $("body").addClass("active-menu");
})

$(".menu__list-url").on("click", function () {
  $("body").removeClass("active-menu");
})


$(".menu__close , .overlay").on("click", function () {
  $("body").removeClass("active-menu");
})



// menu end




// ----------------future-product start--------------



$(".future-product__marquee-items").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
  });



// ----------------future-product end--------------


if ($(window).width() > 768) {
  var rellax = new Rellax('.rellax');
}

// product start



$(".product__title").click(function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass("active");
    $(this).next(".product__dropdown-content").slideUp();
  } else {
    $(".product__dropdown-content").slideUp();
    $(".product__title").removeClass("active");
    $(this).addClass("active");
    $(this).next(".product__dropdown-content").slideDown();
  }
})



$('.product__items').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
  ]
});




$('.product__left-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.product__right-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

// product end



// review start



// Initialize Slick slider
$('.review__items').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  infinite: false, // Disable infinite scrolling for proper arrow logic
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

// Function to update arrow visibility
function updateArrowOpacity(slider) {
  const $slider = $(slider);
  const currentIndex = $slider.slick('slickCurrentSlide');
  const totalSlides = $slider.slick('getSlick').slideCount;
  const slidesToShow = $slider.slick('getSlick').options.slidesToShow;

  // Update left arrow visibility
  const $leftArrow = $slider.siblings('.review__arrow').find('.review__left-arrow');
  if (currentIndex === 0) {
    $leftArrow.removeClass('visible');
  } else {
    $leftArrow.addClass('visible');
  }

  // Update right arrow visibility
  const $rightArrow = $slider.siblings('.review__arrow').find('.review__right-arrow');
  if (currentIndex + slidesToShow >= totalSlides) {
    $rightArrow.removeClass('visible');
  } else {
    $rightArrow.addClass('visible');
  }
}

// Initialize arrow visibility on load
updateArrowOpacity('.review__items');

// Update arrow visibility on slide change
$('.review__items').on('afterChange', function () {
  updateArrowOpacity(this);
});

// Arrow click handlers
$('.review__left-arrow').click(function () {
  $(this).parent().siblings('.review__items').slick('slickPrev');
});
$('.review__right-arrow').click(function () {
  $(this).parent().siblings('.review__items').slick('slickNext');
});



// review end


